import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ft-twoequalcol',
  templateUrl: './twoequalcol.component.html',
  styleUrls: ['./twoequalcol.component.scss'],
})
export class TwoequalcolComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
